import { supabaseUrl } from './supabase';

export function sanitizeStorageKey(key: string): string {
  if (!key) return '';
  return key
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[’‘`]/g, '')
    .replace(/[–—]/g, '-')
    .replace(/[^\w\-\.\/]/g, '_');
}

/**
 * Resolves a coin's storage key or legacy image path to a Supabase CDN public URL.
 * 
 * @param imageKey The relative image path or clean storage key (e.g. '2_euros/standard_by_year/Germany/2002_Germany_2euro.webp')
 * @param type 'thumbnails' (64x64 for album grid & inventory) or 'full' (native res for coin roll hunt inspection)
 */
export function getCoinImageUrl(imageKey?: string | null, type: 'thumbnails' | 'full' = 'full'): string | null {
  if (!imageKey) return null;
  
  // If it's already an absolute HTTP/HTTPS URL, return as is
  if (imageKey.startsWith('http://') || imageKey.startsWith('https://')) {
    return imageKey;
  }

  // Strip leading slashes and directory prefixes
  let clean = imageKey
    .replace(/^\/+/, '')
    .replace(/^coins\//, '')
    .replace(/^euro-coin-images\//, '')
    .replace(/^public\//, '')
    .replace(/\.(jpg|jpeg|png)$/i, '.webp');

  clean = sanitizeStorageKey(clean);

  if (!clean) return null;

  return `${supabaseUrl}/storage/v1/object/public/coin-images/${type}/${clean}`;
}
